import { colors } from "healthex-common/colors";
import styled, { css } from "styled-components";
import { ErrorMessage } from "./FormHelper.styles";
import { HXCheckbox, HXTextField } from "./base.styles";
import { FlexColumn, FlexColumnDiv, FlexRow } from "./common.styles";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import { LittleText } from "./HXMobilePage.styles";
export const Info = styled(FlexColumnDiv) `
    gap: 4px;
`;
export const SignatureTextFieldForResearcher = styled(HXTextField) `
    align-self: stretch;
`;
export const SignatureTextField = styled(HXTextField) `
    align-self: stretch;

    & .MuiOutlinedInput-root {
        height: 48px;
        fieldset {
            border-radius: 12px;
            border-color: ${colors.blue_30};
        }

        &.Mui-focused fieldset {
            border-color: ${colors.blue_main};
        }

        &.Mui-error fieldset {
            border-color: ${colors.tulip_main};
        }

        &:hover fieldset {
            border-color: ${colors.blue_50};
        }
    }

    & .MuiInputBase-input.Mui-disabled {
        -webkit-text-fill-color: unset;
        color: ${colors.black_30};
    }

    & .MuiFormHelperText-root {
        line-height: 100%;
        font-size: ${fontSizes.LITTLE};
    }
`;
export const SigningReasonContainer = styled(FlexColumnDiv) ``;
export const SigningReasonCheckboxForResearcher = styled(HXCheckbox) `
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    align-self: stretch;
    justify-content: center;

    .MuiCheckbox-root {
        padding: 0;
        margin: 0 4px 0 0;
        border-radius: 0;
    }

    .MuiFormControlLabel-label {
        margin-top: 2px;
    }
`;
export const SigningReasonCheckbox = styled(HXCheckbox) `
    flex: 1 0 0;
    .MuiCheckbox-root {
        margin: 0px;
        padding: 12px 4px 12px 20px;

        &:hover {
            background: transparent;
        }
    }

    &.MuiFormControlLabel-root {
        margin: 0px;
    }
`;
export const AISigningReasonContainer = styled(FlexColumn) `
    padding: 20px 0;
    cursor: pointer;
`;
export const AISigningReasonCheckbox = styled(HXCheckbox) `
    flex: 1 0 0;

    .MuiCheckbox-root {
        margin: 0px;
        margin: 0px 12px 0px 0px;
        width: 24px;
        height: 24px;

        &:hover {
            background: transparent;
        }
    }

    &.MuiFormControlLabel-root {
        margin: 0px;

        div {
            ${(props) => props.error &&
    css `
                    color: ${colors.tulip_main};
                `}
        }
    }
`;
export const AISigningReasonText = styled(LittleText) `
    padding-left: 36px;
    color: ${colors.black_lighter};
`;
export const SigningReasonLabel = styled(LittleText).attrs({ grow: true }) `
    margin-left: 8px;
`;
const SigningReasonBaseLeftButtonIcon = css `
    color: ${colors.navy_main};
    width: 24px;
    height: 24px;
    padding: 12px 20px 12px 4px;
    cursor: pointer;
`;
export const SigningReasonInfoOutlinedIcon = styled(InfoOutlinedIcon) `
    ${SigningReasonBaseLeftButtonIcon}
`;
export const SigningReasonOpenInNewOutlinedIcon = styled(OpenInNewOutlinedIcon) `
    ${SigningReasonBaseLeftButtonIcon}
`;
export const SigningReasonError = styled(ErrorMessage) `
    margin: ${(props) => (props.margin ? props.margin : "4px 0 0 14px")};
    font-size: ${fontSizes.LITTLE};
    letter-spacing: 0.15px;
    line-height: 100%;
`;
export const DataUserContainer = styled(FlexColumnDiv) `
    gap: 12px;
`;
export const DataUseText = styled.div `
    color: ${colors.black_main};
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;
    letter-spacing: 0.15px;
`;
export const DataUseTextLink = styled.a `
    color: ${colors.black_main};
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;
    letter-spacing: 0.15px;
    text-decoration: underline;
    padding: 0px;
    cursor: pointer;

    &:hover {
        color: ${colors.black_main};
    }
`;
export const DataUseCheckboxContainer = styled(FlexRow) `
    box-sizing: border-box;
    padding: 12px 0;
    min-height: 72px;
    gap: 12px;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    border: 1px solid ${colors.blue_30};

    ${(props) => props.checked &&
    css `
            background: ${colors.blue_10};
        `}

    ${(props) => props.isError &&
    css `
            border-color: ${colors.tulip_main};
        `}
`;
